/* eslint-disable */

import pinia from "@/store";
import axios from './downloadAxios'
import { ElMessage } from 'element-plus';
import { useUserStore } from '@/store';
import axiosSSO from "./downloadAxiosSSO";
import axiosXXL from "./downloadAxiosXXL";
import axiosMETA from "./downloadAxiosMETA";
import axiosBJH from "./downloadAxiosBJH";
import axiosXHS from "./downloadAxiosXHS";
import axiosTUWEN from "./downloadAxiosTUWEN";
import axiosGEO from "./downloadAxiosGEO";

const store = useUserStore(pinia)

// const XLSX = require('./xlsx')
const XLSX = await import('xlsx')

export function s2ab(s:any) { // 字符串转字符流
  const buf = new ArrayBuffer(s.length)
  const view = new Uint8Array(buf)
  for (let i = 0; i !== s.length; i+=1) {
    view[i] = s.charCodeAt(i) & 0xFF // eslint-disable-line no-bitwise
  }
  return buf
}

export function getCharCol(n:any) { // 将指定的自然数转换为26进制表示。映射关系：[0-25] -> [A-Z]。
  let s = ''
  let m = 0
  while (n > 0) {
    m = n % 26 + 1
    s = String.fromCharCode(m + 64) + s
    n = (n - m) / 26
  }
  return s
}

export function changeData(val:any) {
  let value = ''
  if (!val && val != 0) {
    value = ''
  } else if (typeof val !== 'object') {
    value = val
  } else if (Array.isArray(val)) {
    let str = ''
    val.forEach(item => {
      if (typeof item !== 'object') {
        str = str + item + ','
      } else {
        str = str + JSON.stringify(item) + ','
      }
    })
    value = str
  } else {
    value= JSON.stringify(val)
  }
  return value
}

// 获取数组或对象下的某一项
function childValue(val:any, list:any) {
  if (val) {
    let str = ''
    if (Array.isArray(val)) {
      // 判断是数组
      val.forEach((item, index) => {
        str = str + item[list[1]] + (val.length - 1 != index ? ',' : '')
      })
      return str
    } else {
      // 判断是对象
      return val[list[1]]
    }
  } else {
    return ''
  }
}

export function downloadExl(json:any, downName:any, outFile:any, type?:any) { // 导出到excel
  const keyMap:any = [] // 获取键
  for (const k in json[0]) {
    keyMap.push(k)
  }
  const tmpdata:any = [] // 用来保存转换好的json
  var d = new Date()
  tmpdata['A1'] = {
    v: '导出日期：' + d.toLocaleString()
  }
  json.map((v:any, i:any) => keyMap.map((k:any, j:any) =>{
    if (k.includes('.') && i > 0) {
      const arr = k.split('.')
      return Object.assign({}, {
        v: childValue(v[arr[0]], arr),
        position: (j > 25 ? getCharCol(j) : String.fromCharCode(65 + j)) + (i + 1 +1)
      })
    } else {
      return Object.assign({}, {
        v: v[k],
        position: (j > 25 ? getCharCol(j) : String.fromCharCode(65 + j)) + (i + 1 + 1)
      })
    }
  })).reduce((prev:any, next:any) => prev.concat(next)).forEach(function(v:any) {
    tmpdata[v.position] = {
      v: changeData(v.v)
    }
  })
  const outputPos = Object.keys(tmpdata) // 设置区域,比如表格从A1到D10
  const tmpWB = {
    SheetNames: ['mySheet'], // 保存的表标题
    Sheets: {
      'mySheet': Object.assign({},
        tmpdata, // 内容
        {
          '!ref': outputPos[0] + ':' + outputPos[outputPos.length - 1] // 设置填充区域
        })
    }
  }
  const tmpDown:any = new Blob([s2ab(XLSX.write(tmpWB,
    { bookType: (type === undefined ? 'xlsx' : type), bookSST: false, type: 'binary' } // 这里的数据是用来定义导出的格式类型
  ))], {
    type: ''
  }) // 创建二进制对象写入转换好的字节流
  var href = URL.createObjectURL(tmpDown) // 创建对象超链接
  outFile.download = downName + '.xlsx' // 下载名称
  outFile.href = href // 绑定a标签
  outFile.click() // 模拟点击实现下载
  setTimeout(function() { // 延时释放
    URL.revokeObjectURL(tmpDown) // 用URL.revokeObjectURL()来释放这个object URL
    store.setLoading(false)
  }, 100)
}

export async function downloadFile(outFile: any, name: any, head: any, url: any, query?: any, type?:any) { // 点击导出按钮
  store.setLoading(true)
  if (!outFile) { outFile = document.getElementById('downlink') }
  let num = 1
  let rs:any = []
  if (Array.isArray(url)) {
    rs = url
  } else {
    for (var i = 1; i <= num; i++) {
      let res = null
      if(type == 'sso'){
        res = await axiosSSO({
          url,
          method: 'get',
          params: { ...query, page: i, limit: 1000 }
        })
      }else if(type == 'xxl'){
        res = await axiosXXL({
          url,
          method: 'get',
          params: { ...query, page: i, limit: 1000 }
        })
      }else if(type == 'meta'){
        res = await axiosMETA({
          url,
          method: 'get',
          params: { ...query, page: i, limit: 1000 }
        })
      }else if(type == 'bjh'){
        res = await axiosBJH({
          url,
          method: 'get',
          params: { ...query, page: i, limit: 1000 }
        })
      }else if(type == 'xhs'){
        res = await axiosXHS({
          url,
          method: 'get',
          params: { ...query, page: i, limit: 1000 }
        })
      }else if(type == 'tuwen'){
        res = await axiosTUWEN({
          url,
          method: 'get',
          params: { ...query, page: i, limit: 1000 }
        })
      }else if(type == 'geo'){
        res = await axiosGEO({
          url,
          method: 'get',
          params: { ...query, page: i, limit: 1000 }
        })
      }else {
        res = await axios({
          url,
          method: 'get',
          params: { ...query, page: i, limit: 1000 }
        })
      }
      num = Math.ceil(res.data.page.totalCount / res.data.page.perPage)
      rs = rs.concat(res.data.items)
    }
  }

  if (rs.length == 0) {
    ElMessage.error({
      message: '暂无数据',
      duration: 2 * 1000,
    });
    store.setLoading(false)
    return
  }

  let data:any = [{}]
  // for (const k in rs[0]) {
  //   if (head[k]) {
  //     data[0][k] = head[k]
  //   }
  // }
  for (const k in head) {
    data[0][k] = head[k]
  }
  data = data.concat(rs)
  downloadExl(data, name, outFile)
}